<template>
    <div class="riskypaws-guide">
      <h1 class="guide-title">Riskypaws: a financial framework for your life.</h1>
  
      <h2>Riskypaws uses an acronym to define and identify tools to use to achieve your financial dreams.  A comprehensive approach is as you can save but if you do not manage that wealth through investments inflation will eat away at your savings. 
        
       RiskyPaws = Risk Management, Insure, Save, KYC, Yield Optimization, Planning, Wealth Management and Strategies</h2>
  
      <!-- Tips Cards -->
      <div 
        v-for="(tip, index) in tips" 
        :key="index" 
        :class="['tip-card', tip.level]" 
        @click="navigateToTip(tip)"
      >
        <img :src="require('@/assets/' + tip.image)" alt="Tip Image" class="tip-image" />
        <div class="text-section">
          <h1> {{ tip.topic }}</h1>
          <h2>{{ tip.headline }}</h2>
          <p>{{ tip.description }}</p>
        </div>
      </div>
  
      
    </div>
  
  
  
   
  
  </template>
  
  
  <script>
  import { ref } from 'vue';
  import { useRouter } from 'vue-router';
  
  export default {
    setup() {
      const router = useRouter();
  
      const tips = ref([
  
      {   
          image: '1-risk.png',
          headline: 'Risk Management Intro',
          description: 'Introduction to Risk Management',
          level: 'beginner',
          route: '/riskintro'
        },
      {
          
          image: '1-risk.png',
          headline: 'Calculating Risk',
          description: 'Understand risk measures like a capital markets professional would...explained by us cats so no need to run and hide under the bed',
          level: 'beginner',
          route: '/calculatingrisk'
        },
    
        {
          image: '1-risk.png',
          headline: 'Applying Risk Measures in your everyday Financial Life',
          description: 'Risk is everywhere...you can either run from it or take the time to understand it to make it work for you!',
          level: 'advanced',
          route: '/applyingrisk'
        },
        {
          image: '2-insure.png',
          headline: 'Insurance Policy Premiums',
          description: 'Even saving a small amount consistently can lead to significant growth over time thanks to compound interest.',
          level: 'beginner',
          route: '/insurancepremiums'
        },
        {
          image: '2-insure.png',
          headline: 'Pet Insurance',
          description: 'Too pricey or better to stash money away for a rainy day?',
          level: 'beginner',
          route: '/petinsurance'
        },
        {
          image: '2-insure.png',
          headline: 'Investor Protection',
          description: 'CDIC, CIPF - more letters...what do they mean?',
          level: 'intermediate',
          route: '/investorprotections'
        },
        {
          image: '3-save.png',
          headline: 'Start Small, Grow Big',
          description: 'How compound interest works for you',
          level: 'beginner',
          route: '/compoundinterestcalculator'
        },
        {
          image: '3-save.png',
          headline: 'Pause Now, Spend Later - Use our Cooling Off Period Tool to help you curb your spending',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '3-save.png',
          headline: 'Save Now, Enjoy Later',
          description: 'Let StingyCat create you a budget based on your income and spending',
          level: 'beginner',
          route: '/budget'
        },
        {
          image: '3-save.png',
          headline: 'Leaving money on the table? Explore your RRSP Match',
          description: 'Us cat owners know if we leave something valuable on the table it will be knocked off by our furry friends.  Why leave "free" money from our employer RRSP match?',
          level: 'beginner',
          route: '/budget'
        },
        {
          image: '4-kyc.png',
          headline: 'Do you KYC? (Know Your Cat)',
          description: 'Learn why KYC is so important and why financial institutions ask you about it.  It may surprise you to learn you may not know yourself as well as you think',
          level: 'beginner',
          route: '/kycintro'
        },
      {
        image: '4-kyc.png',
          headline: 'Time Horizon Impact Tool',
          description: 'To visually demonstrate how different investment time horizons can affect the growth of investments.',
          level: 'beginner',
          route: '/timehorizon'
        },
    
        {
          image: '4-kyc.png',
          headline: 'Risk Assessment Tool',
          description: 'Test your skills at approving or denying clients based on what you have learned',
          level: 'advanced',
          route: '/riskassessment'
        },
  
        {
          image: '4-kyc.png',
          headline: 'Life Event Timeline Tool',
          description: 'Test your skills at approving or denying clients based on what you have learned',
          level: 'advanced',
          route: '/creditloanofficer'
        },
  
        {
          image: '5-yield.png',
          headline: 'Shopping for Yields on Deposits',
          description: 'Even saving a small amount consistently can lead to significant growth over time thanks to compound interest.',
          level: 'beginner',
          route: '/yieldchasing'
        },
        {
          image: '5-yield.png',
          headline: 'Interest Rates - What is Prime, SOFR and CORRA now?',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/yieldrates'
        },
        {
          image: '6-planning.png',
          headline: 'Interest Rates - What is Prime, SOFR and CORRA now?',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/yieldrates'
        },
  
        {
          image: '6-planning.png',
          headline: 'Interest Rates - What is Prime, SOFR and CORRA now?',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/yieldrates'
        },
        {
          image: '7-assets.png',
          headline: 'ETF Portfolio Builder',
          description: 'Even saving a small amount consistently can lead to significant growth over time thanks to compound interest.',
          level: 'beginner'
        },
        {
          image: '7-assets.png',
          headline: 'Lazy Portfolios',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/insurance'
        },
        {
          image: '7-assets.png',
          headline: 'Risk Tolerance Assessment',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '7-assets.png',
          headline: 'Risk Management Tools - Portfolios - here comes the math',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
  
        {
          image: '8-wealthmanagement.png',
          headline: 'Stock Screener, Finding Alpha',
          description: 'Even saving a small amount consistently can lead to significant growth over time thanks to compound interest.',
          level: 'beginner'
        },
        {
          image: '8-wealthmanagement.png',
          headline: 'ETF Screener - Are you truly diversified?',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/insurance'
        },
        {
          image: '8-wealthmanagement.png',
          headline: 'Options Trading - Understand your Strategy',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '9-strategies.png',
          headline: 'Options Trading - Understand your Strategy',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '9-strategies.png',
          headline: 'Job Comparison Tool',
          description: 'Even saving a small amount consistently can lead to significant growth over time thanks to compound interest.',
          level: 'beginner'
        },
        {
          image: '9-strategies.png',
          headline: 'Negotiation Tips with your Employer at Appraisal Time',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '9-strategies.png',
          headline: 'Powerful Rental Application Creator',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/insurance'
        },
        {
          image: '9-strategies.png',
          headline: 'Home Buying Toolkit - make the emotional part of homebuying an upfront thing and know what you want',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
        {
          image: '9-strategies.png',
          headline: 'Rental Security Deposits ',
          description: 'Is it a genuine need or just a dopamine hit you are craving?',
          level: 'advanced',
          route: '/coolingoff'
        },
      
        
        // Add other tips as needed...
      ]);
  
      const goBack = () => {
        router.back();
      }
  
      const goToInsurance = () => {
        router.push('/insurance');
      };
  
      const navigateToTip = (tip) => {
        if (tip.route) {
          router.push(tip.route);
        }
      };
  
      return {
        tips,
        goBack,
        goToInsurance,
        navigateToTip
      };
    }
  };
  </script>
  
  
  <style scoped>
  .riskypaws-guide {
    background-color: #4A148C; /* Deep purple background */
    color: #C0C0C0; /* Silver text color */
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .guide-title {
    color: #FFFFFF; /* White text color */
    text-align: center;
    margin-bottom: 40px;
    font-weight: 700;
  }
  
  .tip-card {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 20px;
    border: 1px solid #C0C0C0; /* Silver border */
    background-color: #FFFFFF; /* White background for the card */
    color: #333; /* Dark text for contrast */
    border-radius: 10px;
    cursor: pointer;
    transition: transform 0.3s ease;
  }
  
  .tip-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
  
  .tip-image {
    width: 120px;
    height: 120px;
    margin-right: 25px;
  }
  
  .text-section {
    flex-grow: 1;
  }
  
  .button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  
  .action-button {
    padding: 10px 25px;
    border: none;
    border-radius: 25px;
    font-weight: bold;
    transition: background-color 0.3s, color 0.3s;
    font-size: 16px;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  }
  
  .back-button {
    background-color: #FFFFFF; /* White background */
    color: #4A148C; /* Deep purple text */
  }
  
  .next-button {
    background-color: #C0C0C0; /* Silver background */
    color: #4A148C; /* Deep purple text */
  }
  
  .action-button:hover {
    background-color: #333333; /* Darker background on hover */
    color: #FFFFFF; /* White text on hover */
  }
  
  .action-button .fa {
    margin-right: 8px;
  }
  </style>